import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Compass, ArrowRight } from "lucide-react";

const destinations = [
  { label: "Manifesto", desc: "The flagship analysis", to: "/manifesto" },
  { label: "Intelligence", desc: "Analytical briefs library", to: "/intelligence" },
  { label: "Briefings", desc: "Decision-grade memos", to: "/briefings" },
  { label: "Connect", desc: "Schedule an executive briefing", to: "/connect" },
];

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: Non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-20">
      <div className="max-w-2xl w-full">
        <div className="flex items-center gap-3 mb-8">
          <Compass className="h-5 w-5 text-accent" />
          <p className="text-[10px] uppercase tracking-[0.3em] text-accent font-semibold">
            Off the Map
          </p>
        </div>

        <h1 className="font-display text-6xl md:text-7xl font-bold text-foreground mb-4 tracking-tight">
          404
        </h1>
        <p className="font-display text-2xl md:text-3xl text-foreground/90 mb-3 leading-tight">
          This signal isn't on the grid.
        </p>
        <p className="text-muted-foreground mb-2 leading-relaxed">
          The page you requested doesn't exist — or has been re-architected.
        </p>
        <p className="text-[12px] font-mono text-muted-foreground/60 mb-10 break-all">
          requested: {location.pathname}
        </p>

        <div className="border-t border-border/40 pt-8">
          <p className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground font-medium mb-5">
            Recommended destinations
          </p>
          <div className="grid sm:grid-cols-2 gap-3">
            {destinations.map((d) => (
              <Link
                key={d.to}
                to={d.to}
                className="group flex items-center justify-between border border-border/40 rounded-md p-4 hover:border-accent/40 hover:bg-muted/30 transition-colors"
              >
                <div>
                  <p className="text-sm font-semibold text-foreground">{d.label}</p>
                  <p className="text-[12px] text-muted-foreground">{d.desc}</p>
                </div>
                <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-accent group-hover:translate-x-0.5 transition-all" />
              </Link>
            ))}
          </div>

          <div className="mt-8">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm font-medium text-accent hover:text-accent/80 transition-colors"
            >
              ← Return home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
